import ImageBanner from './imagebanner'
export default ImageBanner